import { Link } from 'react-router-dom';
import Logo from '../../assets/LogoDindorf.png';
import './footer.styles.scss';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Main Footer Content */}
                <div className="footer-content">
                    {/* Company Info */}
                    <div className="footer-section company-info">
                        {/* <div className="company-logo">
                            <img src={Logo} alt="Dindorf Logo" />
                        </div> */}
                        <h3 className="company-name">Dindorf</h3>
                        <p className="company-subtitle">Servicio y Venta Automotor</p>
                        <p className="company-description">
                            Más de 60 años de experiencia en el sector automotor. 
                            Especialistas en mecánica, venta de vehículos y motocicletas.
                        </p>
                        <div className="social-links">
                            <a 
                                href="https://wa.me/5492634588256" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="social-link whatsapp"
                                aria-label="WhatsApp Ventas"
                            >
                                <i className="ri-whatsapp-line"></i>
                            </a>
                            <a 
                                href="https://wa.me/2635000305" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="social-link whatsapp-service"
                                aria-label="WhatsApp Servicios"
                            >
                                <i className="ri-customer-service-line"></i>
                            </a>
                            <a 
                                href="mailto:info@dindorf.com" 
                                className="social-link email"
                                aria-label="Email"
                            >
                                <i className="ri-mail-line"></i>
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-section">
                        <h4 className="section-title">Enlaces Rápidos</h4>
                        <nav className="footer-nav">
                            <Link to="/" className="footer-link">Inicio</Link>
                            <Link to="/nosotros" className="footer-link">Nosotros</Link>
                            <Link to="/equipo" className="footer-link">Nuestro Equipo</Link>
                            <Link to="/servicios" className="footer-link">Servicios</Link>
                        </nav>
                    </div>

                    {/* Vehicles */}
                    <div className="footer-section">
                        <h4 className="section-title">Vehículos</h4>
                        <nav className="footer-nav">
                            <Link to="/usados" className="footer-link">Vehículos Usados</Link>
                            <Link to="/0km" className="footer-link">Vehículos 0KM</Link>
                            <Link to="/motos" className="footer-link">Motocicletas</Link>
                        </nav>
                    </div>

                    {/* Services */}
                    <div className="footer-section">
                        <h4 className="section-title">Servicios</h4>
                        <div className="services-list">
                            <span className="service-item">Mecánica General</span>
                            <span className="service-item">Motores</span>
                            <span className="service-item">Frenos</span>
                            <span className="service-item">Caja y Embrague</span>
                            <span className="service-item">Inyección Electrónica</span>
                            <span className="service-item">Correa de Distribución</span>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div className="footer-section contact-info">
                        <h4 className="section-title">Contacto</h4>
                        <div className="contact-details">
                            <div className="contact-item">
                                <i className="ri-map-pin-line"></i>
                                <div className="contact-text">
                                    <span>Calle Vicuña Prado</span>
                                    <span>Rivadavia, Mendoza</span>
                                </div>
                            </div>
                            <div className="contact-item">
                                <i className="ri-phone-line"></i>
                                <div className="contact-text">
                                    <a href="tel:+5492634588256">Ventas: +54 9 263 458-8256</a>
                                    <a href="tel:+542635000305">Servicios: +54 263 500-0305</a>
                                </div>
                            </div>
                            <div className="contact-item">
                                <i className="ri-time-line"></i>
                                <div className="contact-text">
                                    <span>Lun - Vie: 8:00 - 18:00</span>
                                    <span>Sáb: 8:00 - 13:00</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <div className="copyright">
                            <p>&copy; {currentYear} Dindorf Servicio y Venta Automotor. Todos los derechos reservados.</p>
                        </div>
                        <div className="footer-bottom-links">
                            <span className="footer-link">Términos y Condiciones</span>
                            <span className="footer-link">Política de Privacidad</span>
                        </div>
                        <div className="developer-credit">
                            <p>Desarrollado por JPBT</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Floating Action Buttons for Mobile */}
            <div className="mobile-action-buttons">
                <a 
                    href="https://wa.me/5492634588256?text=Hola,%20quisiera%20información%20sobre%20vehículos"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mobile-action-btn ventas"
                >
                    <i className="ri-car-line"></i>
                    <span>Ventas</span>
                </a>
                <a 
                    href="https://wa.me/2635000305?text=Hola,%20quisiera%20consultar%20sobre%20servicios"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mobile-action-btn servicios"
                >
                    <i className="ri-tools-line"></i>
                    <span>Servicios</span>
                </a>
            </div>
        </footer>
    );
};

export default Footer;